














































































import { Component, Vue, Ref, Watch } from "vue-property-decorator";

@Component({
  name: "Contact"
})
export default class Contact extends Vue {
  valid: boolean = false;
  firstname: string = "";
  lastname: string = "";
  tel: string = "";
  nameRules: any[] = [
    (v: any) => !!v || "Bitte Namen eintragen.",
    (v: any) =>
      v.length <= 50 || "Dein Name darf nicht mehr als 50 Zeichen haben"
  ];
  email: string = "";
  emailRules: any[] = [
    (v: any) => !!v || "Bitte E-mail eingeben",
    (v: any) => /.+@.+/.test(v) || "E-mail muss gültig sein."
  ];
  select: any = null;
  items: string[] = ["Anfrage", "Angebot"];
  textRules: any[] = [
    (v: any) => !!v || "Bitte Text eingeben. ",
    (v: any) =>
      v.length <= 250 || "Dein Text muss weniger als 250 Zeichen haben."
  ];
  @Ref("form") readonly form!: any;
  validate() {
    if (this.form.validate()) {
    }
  }
  reset() {
    this.form.reset();
  }
  resetValidation() {
    this.form.resetValidation();
  }
}
